export default function (val) {
  val = val.toString()
  return val !== '0' ? 
    `Rp${parseFloat(val.replace(/,/g, '')).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}` :
    'FREE'
}